/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import jwt_decode from "jwt-decode";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import authActions from '../../redux/features/auth/actions';
import useAuthorizedEpApps from '../../hooks/useAuthorizedEpApps';
import config from '../../config/config';
import { PERFORMANCE_INSIGHTS_APP_NAME } from '../../constants';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import AdminPageComp from '../../components/AdminPageComp/AdminPageComp';
import styles from './AdminPage.module.css';
import { saveLogToBackend } from '../../api';

const { API_BASE_URL } = config;

const AdminPage = ({
  isAuthenticated,
  authPolicies,
  currentUserId,
}) => {

  const authorizedApps = useAuthorizedEpApps(isAuthenticated, authPolicies);
  const { showLoading } = usePopupManager();
  const history = useHistory();

  useEffect(() => {
    if (
      authorizedApps.length &&
      !authorizedApps.includes(PERFORMANCE_INSIGHTS_APP_NAME)
    ) {
      showLoading();
      window.location.replace(config.HOME_UI_BASE_URL);
    }
  }, [authorizedApps, currentUserId]);

  const [hasAdminAccess, setHasAdminAccess] = useState(true);

  const logData = {
    username: localStorage.getItem("preferred_username") || "anonymous",
    page: window.location.pathname,
    method: "PAGE_VISIT",
    url: window.location.href,
    status: "SUCCESS",
    duration: 0,
    timestamp: new Date().toISOString(),
  };

  useEffect(() => {
    saveLogToBackend(logData);
  }, []);

  useEffect(() => {
    const getUserRoles = async () => {
      try {
        const headerss = new Headers();
        headerss.append("Content-Type", "application/json");
        const url = `${API_BASE_URL}/api/token/auth`;
        const TokenData = keycloak.token;
        const decoded = jwt_decode(TokenData);
        const userName = decoded.preferred_username;
        const response = await fetch(url, {
          method: "POST",
          headers: headerss,
          body: JSON.stringify({ username: userName }),
        });
        const data = await response.json();
        const UserData = Array.isArray(data.SuperUserRole) ? data.SuperUserRole : [];
        if (UserData.includes('AdminPageAccess')) {
          setHasAdminAccess(true);
        } else {
          setHasAdminAccess(false);
        }
      } catch (err) {
        console.error(err);
      }
    };
    getUserRoles();
  }, []);

  const handleRedirectClick = () => {
    history.push('/');
  }

  return (
    <div className={styles.container}>
      {!hasAdminAccess ? (
        <div className="container mt-4">
          <h3 className="mb-4 text-center" style={{ color: "#0067ac" }}>
            You don't have access to the Admin Dashboard.
          </h3>
          <div className="d-flex justify-content-center">
            <button className="btn mb-4" style={{ backgroundColor: "#28a745", borderColor: "#28a745", color: "#fff" }} onClick={handleRedirectClick}>
              Go to Home
            </button>
          </div>
        </div>
      ) : (
        <AdminPageComp />
      )}
    </div>
  )
}

AdminPage.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  authPolicies: PropTypes.object.isRequired,
  currentUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

export default connect(({ auth, userProfile }) => ({
  isAuthenticated: auth.isAuthenticated,
  authPolicies: auth.authPolicies,
  currentUserId: userProfile.userId,
  setAuthToken: authActions.setAuthToken,
}))(AdminPage);
